/**
 * Centralized event listener for unloading engagements to fix Bug 29930.
 * Idle time out handler removes this event listener before redirecting user to logout.
 */
export function handleLeavePage (e: BeforeUnloadEvent) {
  return (e.returnValue =
    'You have unsaved changes that will be lost if you leave this page.')
}
